import React, { FC } from 'react';
import { NavigationProps } from '@interfaces/navigation';
import MachinesProvider from '@v2/pages/machines/common/providers/MachinesProvider/MachinesProvider';
import OperatorPanelScheduled from '@components/operatorPanel/components/OperatorPanelScheduled';
import { scale } from '@components/frame';
import { font } from '@styles/fonts';
import { connect } from 'react-redux';
import { isPhone, isPhoneNative, isWeb } from '@helpers';
import { MODE } from '@v2/pages/machines/common/enums';
import { TimelineItemsList } from '@v2/pages/machines/modules/timeline/components/TimelineItemsList/TimelineItemsList';
import { useManageScheduledScreen } from './hooks/useManageScheduledScreen';
import { TABLE_NAMES } from '@v2/pages/common/constants/base.constants';
import { useTrackMachineScheduledOpened } from './hooks/useTrackMachineScheduledOpened';

interface ScheduledProps extends NavigationProps {}

const ScheduledComponent: FC<ScheduledProps> = ({ lg }) => {
  useTrackMachineScheduledOpened();
  const { detailsWidth, fullWidth, isAllSelected, machineScreenMainBg, mode, onScheduledJobPress } = useManageScheduledScreen();

  return (
    <MachinesProvider
      lg={lg}
      panelViewMode={false}
      onBack={() => {}}
      mode={isWeb ? mode : isPhone ? MODE.DETAILS : MODE.FULL}
      getList={(props) => <TimelineItemsList {...props} />}
    >
      <OperatorPanelScheduled
        customBg={machineScreenMainBg}
        containerWidth={isPhone ? fullWidth : detailsWidth}
        bottomSheetLayout={false}
        scale={scale}
        font={font}
        onScheduledJobPress={onScheduledJobPress}
        headerStyle={{ paddingTop: 0 }}
        withoutCloseButton
        withoutHeaderTitle
        shouldTrackSelectedMachine
        jobMainAppTileView
        showModeSelectorInPopupMode
        shouldUseDefaultHorizontalPaddings={isPhoneNative}
        searchInputViewSelectorBg="Background/Light/Search & View Selector"
        searchInputWithModeSelectorStyle={isAllSelected ? { marginTop: 0 } : undefined}
        tableName={TABLE_NAMES.machineScheduled}
      />
    </MachinesProvider>
  );
};

const Scheduled = connect(({ machines: { selectedItem } }) => ({ selectedItem }), {})(ScheduledComponent);

export { Scheduled };
